import type { FileImportSummaryResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toFile } from './toFile';

// Builds a normalized Data.File domain from a list of File DTOs.
// FileImportSummaryResponse is itself the array type after the OpenAPI regen.
function toFileDomain(args: { dtos: FileImportSummaryResponse }) {
  const { dtos } = args;

  const fileDomain: NormalizedDomain<Data.File> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const file = toFile(item);
      domainUtility.mutateAdd(fileDomain, file);
    },
  });

  return { fileDomain };
}

export { toFileDomain };
